import { useEffect, useState } from 'react';

// One answer to "is this a phone-sized screen?" for every page (Tailwind's md = 768 px), so the
// mobile layouts switch at the same width everywhere. Claude, 2026-09-28.
const QUERY = '(max-width: 767px)';

export function isPhoneNow(): boolean {
  try { return window.matchMedia(QUERY).matches; } catch { return false; }
}

export function useIsPhone(): boolean {
  const [phone, setPhone] = useState(isPhoneNow);
  useEffect(() => {
    let mq: MediaQueryList;
    try { mq = window.matchMedia(QUERY); } catch { return; }
    const on = () => setPhone(mq.matches);
    mq.addEventListener ? mq.addEventListener('change', on) : mq.addListener(on);
    return () => { mq.removeEventListener ? mq.removeEventListener('change', on) : mq.removeListener(on); };
  }, []);
  return phone;
}
